import type EnType from '../en-US/apiRunnerSplitPane';

export default {
  'apiRunnerSplitPane.request': 'Editor de Requisição',
  'apiRunnerSplitPane.response': 'Response',
  'apiRunnerSplitPane.vertical': 'Dividir Verticalmente',
  'apiRunnerSplitPane.horizontal': 'Dividir Horizontalmente',
  'apiRunnerSplitPane.none': 'Sem Divisão',
} satisfies typeof EnType;
